import { message } from "antd";
import { TaskFormCard } from "./components/TaskForm";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Task } from "@rumble-it/common-lib/types/models/Task.interface";
import { createTask } from "../../../lib/api/resources/tasks";
import { useNavigate } from "react-router-dom";
import { User } from "@rumble-it/common-lib/types/models/User.interface";
import { fetchUsersWithoutPagination } from "@/lib/api/resources/users";
import { Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";

export const TaskCreate = ({
  onSuccess,
  dossier,
}: {
  onSuccess: () => void;
  dossier: Dossier | undefined;
}) => {
  const navigate = useNavigate();

  const { data: users, isLoading: isUsersLoading } = useQuery({
    queryKey: ["Users"],
    queryFn: () => fetchUsersWithoutPagination(),
  });

  const userOptions = Array.isArray(users?.member)
    ? users?.member.map((acc: User) => ({
        label: acc.fullName,
        value: acc["@id"],
      }))
    : [];

  const createTaskMutation = useMutation({
    mutationFn: (data: Task) => {
      // When a dossier is provided, append dossier id to the payload
      const payload: Task = { ...data };
      if (dossier?.["@id"]) {
        payload.dossier = dossier["@id"];
      }
      return createTask(payload);
    },
    onSuccess: () => {
      onSuccess ? onSuccess() : navigate("/claims/tasks");
      message.success("Taak succesvol aangemaakt");
    },
  });

  return (
    <div className="w-[800px] max-w-full">
      <TaskFormCard
        loading={isUsersLoading}
        userOptions={userOptions}
        mutation={createTaskMutation}
      />
    </div>
  );
};
